import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Letters from "./Letters";

function Homee() {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/withreviews`)
      .then((res) => res.json())
      .then((data) => setUsers(data))
      .catch((err) => console.error("Failed to fetch:", err));
  }, []);

  const handleClick = (userId) => {
    navigate(`/user/${userId}`);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Users with Reviews</h2>

      {/* Letters row */}
      <Letters setUsers={setUsers} />

      {/* Results */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
        {users.map((user, idx) => (
          <div
            key={idx}
            onClick={() => handleClick(user._id)}
            style={{
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "10px 15px",
              background: "#f1f1f1",
              cursor: "pointer",
              minWidth: "150px",
            }}
          >
            <strong>{user.name}</strong> ({user.review_count} reviews)
          </div>
        ))}
      </div>
    </div>
  );
}

export default Homee;
